if (!customElements.get("quick-add")) {
  class QuickAdd extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector("button");
      this.button.addEventListener("click", this._handleClick.bind(this));
    }

    _handleClick(e) {
      e.preventDefault();

      // const formData = {
      //   items: [
      //     {
      //       id: parseInt(this.button.dataset.variant),
      //       quantity: 1,
      //     },
      //   ],
      // };

      let formData = new FormData(this.form);

      formData.append("id", parseInt(this.button.dataset.variant));
      formData.append("quantity", 1);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body: formData,
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          // console.log("DATA: ", JSON.parse(data))

          // FETCH CART AFTER ADDING ITEM
          fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
          })
            .then((res) => {
              return res.text();
            })
            .then((newCart) => {
              const parsedNewCart = JSON.parse(newCart);

              document.dispatchEvent(
                new CustomEvent("itemToCart", {
                  bubbles: true,
                  detail: {
                    id: formData.get("id"),
                    quantity: formData.get("quantity"),
                  },
                })
              );

              document.dispatchEvent(
                new CustomEvent("cartAdd", {
                  bubbles: true,
                  detail: parsedNewCart,
                })
              );

              document.dispatchEvent(
                new CustomEvent("cartUpdate", {
                  detail: parsedNewCart,
                })
              );

              return newCart;
            })
            .catch((err) => console.log("ERROR: ", err));

          document.dispatchEvent(
            new CustomEvent("cartOpen", {
              bubbles: true,
            })
          );

          return data;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }
  customElements.define("quick-add", QuickAdd);
}
